<template>
  <div class="basket-item row col-12 col-md-6" style="padding: 5px">
    <div class="content row col-12 justify-center" style="padding: 5px">
      <div class="row text col-7">
        <div class="col-12 name">{{ info.hema_name_en }}</div>
        <div class="col-12 brand">{{ info.hema_brand_en }}</div>
      </div>
      <div class="col-5 row justify-center self-center">
        <q-btn round flat icon="add" @click="onAddItem"/>
        <q-input dense readonly outlined v-model="product.quantity" style="width: 50px;" input-class="text-center"/>
        <q-btn round flat icon="remove" @click="onSubtractItem"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BasketItem",
  props: ["product"],
  data() {
    return {
        info: this.product,
    };
  },
  methods: {
    onAddItem(){
        this.info.quantity++;
        return;
    },
    onSubtractItem(){
        this.info.quantity--;
        return;
    }
  },
};
</script>

<style scoped>

* {
  color: #2c2a74;
}
.content {
  background: white;
}
.name {
  font-size: 1.3em;
}

</style>
